// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FaQD","question":"styles_question__3oXZd","description":"styles_description__29VVR"};